// modules
import { createSelector } from 'reselect'

const billing = (state) => state.actions.billing

export const billingActivityLogList$ = createSelector(
  billing,
  (billing) => billing.billingActivityLogList
)

export const billingActivityLoader$ = createSelector(
  billing,
  (billing) => billing.loader
)

export const billingBatchList$ = createSelector(
  billing,
  (billing) => billing.billingBatchList
)

export const batchInvoice$ = createSelector(
  billing,
  (billing) => billing.batchInvoice
)

export const invoiceDetails$ = createSelector(
  billing,
  (billing) => billing.invoiceDetails
)

export const invoiceActivityLog$ = createSelector(
  billing,
  (billing) => billing.invoiceActivityLog
)

export const isBillingLoad$ = createSelector(
  billing,
  (billing) => billing.isBillingLoad
)
